import { ParsedUrlQuery } from 'querystring';

export function getPriceMax(query: ParsedUrlQuery) {
    if (query['price_max']) {
        return query['price_max'];
    }

    return '';
}
